import { useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';
import { getCurrentUser, updateUserLastActive } from '../services/userService';

const UPDATE_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function useActivityTracker() {
  const throttled = useRef();

  useEffect(() => {
    throttled.current = throttle(() => {
      const user = getCurrentUser();
      if (!user) return;
      updateUserLastActive(user.uid);
    }, UPDATE_INTERVAL_MS);

    const handler = () => throttled.current && throttled.current();

    const events = ['click', 'keydown', 'pointermove', 'visibilitychange'];
    events.forEach(e => window.addEventListener(e, handler));

    return () => events.forEach(e => window.removeEventListener(e, handler));
  }, []);
}
